import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AppStore } from '@kanek/data-access';

@Component({
  selector: 'kanek-root',
  imports: [RouterOutlet],
  template: `
    <main>
      <router-outlet />
    </main>
  `,
  styles: `
    main {
      height: 100%;
    }
  `
})
export class AppComponent implements OnInit {
  appStore = inject(AppStore);
  router = inject(Router);

  ngOnInit(): void {
    console.log('ngOnInit()');
    this.appStore.setDarkMode(true);
  }
}
